import { trackConfirmedLead } from '@theme/lead-measurement';
let pendingRuntime;

function initializeForms() {
  if (pendingRuntime) return pendingRuntime;
  pendingRuntime = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://server.fillout.com/embed/v1/';
    script.async = true;
    script.onload = () => { script.remove(); resolve(); };
    script.onerror = () => { script.remove(); reject(new Error('Form runtime unavailable')); };
    document.head.append(script);
  }).finally(() => { pendingRuntime = undefined; });
  return pendingRuntime;
}

class DeferredFillout extends HTMLElement {
  #observer;
  #started = false;
  #titleObserver;
  #submission = event => {
    const form = this.querySelector('[data-fillout-id="emWMacYuUrus"]');
    if (!form || !event.data || typeof event.data !== 'object' || event.data.type !== 'form_submit') return;
    const frame = form.querySelector('iframe');
    if (!frame || event.source !== frame.contentWindow) return;
    try {
      const url = new URL(frame.src);
      if (url.origin !== 'https://embed.fillout.com' || event.origin !== url.origin ||
          url.pathname !== '/t/emWMacYuUrus' ||
          event.data.embedId !== url.searchParams.get('fillout-embed-id') ||
          typeof event.data.submissionUuid !== 'string' ||
          !/^[a-zA-Z0-9-]{8,100}$/.test(event.data.submissionUuid)) return;
      trackConfirmedLead('catering', event.data.submissionUuid);
    } catch { /* A provider message must never affect the form itself. */ }
  };

  #nameFrames = () => {
    const title = this.dataset.formTitle;
    if (!title) return;
    for (const frame of this.querySelectorAll('iframe')) {
      if (frame.title !== title) frame.title = title;
    }
  };

  connectedCallback() {
    window.addEventListener('message', this.#submission);
    this.#titleObserver = new MutationObserver(this.#nameFrames);
    this.#titleObserver.observe(this, { childList: true, subtree: true, attributes: true, attributeFilter: ['title'] });
    this.#nameFrames();
    if (this.#started) return;
    if (!('IntersectionObserver' in window)) {
      this.#load();
      return;
    }
    this.#observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) this.#load();
    });
    this.#observer.observe(this);
  }

  disconnectedCallback() {
    window.removeEventListener('message', this.#submission);
    this.#titleObserver?.disconnect();
    this.#observer?.disconnect();
  }

  async #load() {
    if (this.#started) return;
    this.#started = true;
    this.#observer?.disconnect();
    const template = this.querySelector('template');
    if (!template) return;
    this.append(template.content.cloneNode(true));
    const form = this.querySelector('[data-fillout-id]');
    try {
      await initializeForms();
      if (!form.hasAttribute('data-fillout-initialized')) await initializeForms();
    } catch {
      this.style.minHeight = '0';
      form.remove();
    }
  }
}

if (!customElements.get('deferred-fillout')) customElements.define('deferred-fillout', DeferredFillout);
